Vue.component('specificeren', require('./components/product/specificeren.vue'));
Vue.component('specificeren-v2', require('./components/product/specificeren-v2.vue'));
Vue.component('specificeren-vrij', require('./components/product/specificeren-vrij'));

var app = new Vue({
    el: '#specificeren',
    data: {
        message: 'Hello Vue!'
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/specificeren.js